import { Component, OnInit, Input } from '@angular/core';
// import { parse } from 'path';

@Component({
  selector: 'app-grievance-time-line-details',
  templateUrl: './grievance-time-line-details.component.html',
  styleUrls: ['./grievance-time-line-details.component.scss']
})
export class GrievanceTimeLineDetailsComponent implements OnInit {
  @Input() grievanceHistoryData: any;
  data: any;
  constructor() { 
  }

  ngOnInit() {
    const local = localStorage.getItem('timeLine');
    this.data = JSON.parse(local);
  }



}
